module.exports = __webpack_public_path__ + "static/media/ye.afa7b6b8.svg";